/**
 * Addon Products for Prestige Theme - With Inventory Support
 * Version: 16.0
 */

(function() {
  'use strict';

  class AddonProducts {
    constructor() {
      this.container = document.querySelector('[data-addon-products-container]');
      this.mainProductForm = document.querySelector('form[action*="/cart/add"]');
      
      if (!this.container || !this.mainProductForm) return;
      
      this.checkboxes = Array.from(this.container.querySelectorAll('[data-addon-variant-id]:not(:disabled)'));
      this.totalDisplay = this.container.querySelector('[data-addon-total]');
      this.selectedAddons = [];
      
      this.attachEvents();
      this.updateTotal();
    }

    attachEvents() {
      // Listen for the theme's variant:add event
      document.addEventListener('variant:add', (e) => {
        this.selectedAddons = this.getSelectedAddons();
        
        if (this.selectedAddons.length > 0) {
          setTimeout(() => {
            this.addSelectedAddons();
          }, 100);
        }
      });

      // Listen for cart:change to update the drawer
      document.addEventListener('cart:change', (e) => {
        this.refreshCartDrawer(e.detail.cart);
      });

      // Update total when checkboxes change
      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          this.updateTotal();
        });
      });
    }

    getMainVariantId() {
      const hiddenInput = this.mainProductForm.querySelector('input[name="id"][type="hidden"]');
      return hiddenInput?.value || null;
    }

    getMainQuantity() {
      const quantityInput = this.mainProductForm.querySelector('input[name="quantity"]');
      return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    }

    getSelectedAddons() {
      // Only get checkboxes that are checked and not disabled
      return this.checkboxes.filter(checkbox => checkbox.checked && !checkbox.disabled);
    }

    updateTotal() {
      if (!this.totalDisplay) return;
      
      const selectedAddons = this.getSelectedAddons();
      const total = selectedAddons.reduce((sum, checkbox) => {
        return sum + (parseFloat(checkbox.dataset.addonPrice) || 0);
      }, 0);
      
      if (selectedAddons.length > 0) {
        this.totalDisplay.style.display = 'flex';
        const totalElement = this.totalDisplay.querySelector('[data-addon-total-price]');
        if (totalElement) {
          totalElement.textContent = `€${total.toFixed(2)}`;
        }
      } else {
        this.totalDisplay.style.display = 'none';
      }
    }

    async addSelectedAddons() {
      const addonItems = this.selectedAddons.map(checkbox => ({
        id: parseInt(checkbox.dataset.addonVariantId),
        quantity: 1
      }));

      try {
        for (const item of addonItems) {
          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('quantity', item.quantity);

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (!response.ok) {
            const error = await response.json();
            console.error('Error adding item:', error);
            // Continue with other items even if one fails
          }
        }

        const cartResponse = await fetch('/cart.js');
        const updatedCart = await cartResponse.json();

        await this.forceCartRefresh(updatedCart);

        this.checkboxes.forEach(cb => cb.checked = false);
        this.selectedAddons = [];
        this.updateTotal();

        this.showMessage('Addons added to your cart!', 'success');

      } catch {
        this.showMessage('Error adding addons', 'error');
      }
    }

    async forceCartRefresh(cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { 
          cart: cart,
          baseEvent: 'variant:add'
        }
      }));

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.refresh === 'function') {
          await cartDrawer.refresh();
        }
        if (typeof cartDrawer.show === 'function') {
          cartDrawer.show();
        }
      }

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      setTimeout(() => {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }, 500);
    }

    refreshCartDrawer(cart) {
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer) {
        if (cartDrawer.items) {
          cartDrawer.items = cart.items;
        }
        
        cartDrawer.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
      }

      const cartCount = document.querySelector('.cart-count, [data-cart-count]');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
    }

    showMessage(text, type = 'success') {
      const oldMessages = this.mainProductForm.querySelectorAll('.banner, .notification, .alert');
      oldMessages.forEach(msg => msg.remove());
      
      const message = document.createElement('div');
      message.className = `banner banner--${type}`;
      message.textContent = text;
      message.style.cssText = 'margin:0 0 20px 0;padding:12px 16px;border-radius:4px;' + 
        (type === 'success' 
          ? 'background:#e6f3e6;color:#1e7e1e;border:1px solid #b7dab7;' 
          : 'background:#fbe9e9;color:#b02b2b;border:1px solid #f5c6c6;');
      
      this.mainProductForm.insertBefore(message, this.mainProductForm.firstChild);
      setTimeout(() => message.remove(), 3000);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new AddonProducts());
  } else {
    new AddonProducts();
  }

})();